import React from "react";

const CHUNK_ERROR_REGEX =
  /ChunkLoadError|Loading chunk [\d]+ failed|dynamically imported module/i;

export function lazyWithRetry<T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
  retryKey: string
) {
  return React.lazy(async () => {
    try {
      return await importer();
    } catch (error: any) {
      const message = String(error?.message || "");
      const isChunkError = CHUNK_ERROR_REGEX.test(message);

      if (isChunkError) {
        const storageKey = `lazy-retry:${retryKey}`;
        const hasRetried = sessionStorage.getItem(storageKey) === "1";

        if (!hasRetried) {
          sessionStorage.setItem(storageKey, "1");
          window.location.reload();
          return new Promise<{ default: T }>(() => {});
        }

        sessionStorage.removeItem(storageKey);
      }

      throw error;
    }
  });
}
